const styles = (theme) => ({
  link: {
    '-webkit-tap-highlight-color': 'transparent',
    fontSize: 16,
    color: theme.color.black_11,
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  menuItemIcon: {
    minWidth: 30,
    marginTop: 12,
    '& path': {
      fill: 'inherit',
    },
  },
  menuItemIconSmall: {
    minWidth: 25,
    marginTop: 12,
    '& path': {
      fill: 'inherit',
    },
  },
  menuItemIconContactWithMe: {
    minWidth: 30,
    marginTop: 12,
  },
  menuItemIconContactWithMeSmall: {
    minWidth: 20,
    marginTop: 12,
  },
  icon: {
    width: 20,
    height: 20,
  },
  text: {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  activeAvatar: {
    background: theme.color.teal,
    fill: theme.color.white,
  },
  avatar: {
    backgroundColor: theme.color.black_11,
    fontSize: 16,
  },
  newAvatar: {
    backgroundColor: theme.color.teal,
    fontSize: 16,
  },
  empty: {
    width: 48,
  },
  assetsBalance: {
    textOverflow: 'clip',
  },
  annualSpend: {
    marginRight: 10,
  },
  pills: {
    marginRight: 10,
  },
  marginLeft: {
    marginLeft: 10,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
  },
  nameWrapper: {
    // These 4 properties allow the name to be truncated with ellipsis
    //  (along with display: 'flex' in the header)
    flexShrink: 100,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  preferredName: {
    opacity: 0.6,
    fontWeight: 300,
    marginLeft: 5,
  },
  stanleyIconsWrapper: {
    flexShrink: 0,
    display: 'inline-flex',
    alignItems: 'center',
  },
  cityFontSize: {
    fontSize: '14px',
  },
  calendarIcon: {
    width: 10,
    height: 10,
  },
});

export default styles;
